import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider } from 'react-redux'; // eslint-disable-line
import { store } from 'store';
import { PostHogProvider } from 'posthog-js/react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n.ts';
import { APIProvider } from '@vis.gl/react-google-maps';

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <APIProvider
      apiKey={'AIzaSyDMQZsQHvYwCDSMTkxm4MJu_lvzdXoskso'}
    >
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          {process.env.REACT_APP_PUBLIC_POSTHOG_KEY ? (
            <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY} options={options}>
              <Suspense fallback={<div>Loading translation...</div>}>
                <App />
              </Suspense>
            </PostHogProvider>
          ) : (
            <Suspense fallback={<div>Loading translation...</div>}>
              <App />
            </Suspense>
          )}
        </Provider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </APIProvider>
  </React.StrictMode>,
);

reportWebVitals();
